import { render } from "./SignatureUpload.vue?vue&type=template&id=66a446d2&scoped=true"
import script from "./SignatureUpload.vue?vue&type=script&lang=js"
export * from "./SignatureUpload.vue?vue&type=script&lang=js"

import "./SignatureUpload.vue?vue&type=style&index=0&id=66a446d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a446d2"]])

export default __exports__